import axios, { AxiosInstance } from 'axios';
import { getBaseUrl, getInstanceId, getRequestHeaders, notifyUnauthorised } from '../../evo/runtime';

const api = (): AxiosInstance => {
  const axiosInstance = axios.create({ baseURL: `${getBaseUrl()}/` });

  axiosInstance.interceptors.request.use(async (config) => {
    const headers = await getRequestHeaders();
    Object.entries(headers).forEach(([key, value]) => {
      config.headers.set(key, value);
    });

    // The API resolves the property per request, so every call has to name the
    // subscription this session was resolved to. Sent as a query parameter as
    // well as a header because not every host forwards custom headers.
    const instanceId = getInstanceId();
    if (instanceId) {
      config.params = { ...(config.params as Record<string, unknown> | undefined), evoInstanceId: instanceId };
    }

    return config;
  });

  axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
      const statusCode = error?.response?.status ?? '';

      if (statusCode === 401) {
        notifyUnauthorised();
      }

      return Promise.reject({
        success: false,
        message: error?.response?.data?.message || error?.response?.data?.error || 'Something went wrong.',
        status: statusCode,
        raw: error,
      });
    },
  );

  return axiosInstance;
};

export default api;
